.mainWrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-area: auto;
}

.sportsPageHubContentContainer {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  max-width: var(--ogm-max-width);
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  display: grid;
  grid-template-rows: auto;
  gap: 20px;
  padding: 0 16px;
}

/* The container's own top margin is inter-section spacing (breadcrumbs/header -> content grid) — when
   the inline-banner ad leads the content grid instead, that margin lands directly above the ad and
   reads as an oversized gap above it. Compound selector (two classes) beats the plain/media-query
   `.sportsPageHubContentContainer` rules below regardless of source order or breakpoint. */
.sportsPageHubContentContainer.leadsWithInlineBanner {
  margin-top: 15px;
}

@media (min-width: 768px) {
  .sportsPageHubContentContainer {
    gap: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}

.sportsPageHubNoOddsFallbackCell {
  grid-area: centerTop;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: hidden;
}

.standard {
  grid-template-areas:
    'centerTop'
    'centerBottom';
  grid-template-columns: 1fr;
}

.standardWithRight {
  grid-template-areas:
    'centerTop'
    'right'
    'centerBottom';
  grid-template-columns: 1fr;
}

@media (min-width: 1024px) {
  .standardWithRight {
    grid-template-areas:
      'centerTop right'
      'centerBottom right';
    grid-template-columns: 1fr minmax(300px, 360px);
    grid-template-rows: auto 1fr;
  }
}

.sportsPageHubCenterTop,
.sportsPageHubRight,
.sportsPageHubCenterBottom {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: hidden;
}

.sportsPageHubContentContainer > .sportsPageHubCenterTop:last-child,
.sportsPageHubContentContainer > .sportsPageHubRight:last-child,
.sportsPageHubContentContainer > .sportsPageHubCenterBottom:last-child {
  gap: 0;
}

.sportsPageHubCenterTop {
  grid-area: centerTop;
}

.sportsPageHubRight {
  grid-area: right;
}

.sportsPageHubCenterBottom {
  grid-area: centerBottom;
}

.sportsPageHubContentContainer > *,
.sportsPageHubNoOddsFallbackCell > *,
.sportsPageHubCenterTop > *,
.sportsPageHubRight > *,
.sportsPageHubCenterBottom > *,
.sportsPageHubBottom > * {
  max-width: 100%;
}
